import { render, staticRenderFns } from "./BreadCrumbs.vue?vue&type=template&id=766ae85a&scoped=true&"
import script from "./BreadCrumbs.vue?vue&type=script&lang=ts&"
export * from "./BreadCrumbs.vue?vue&type=script&lang=ts&"
import style0 from "./BreadCrumbs.vue?vue&type=style&index=0&id=766ae85a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "766ae85a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VIcon,VRow})
